import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "start" }}>
            Hi Everyone, I am <span className="purple">Abdallah Alqashqish </span>
            from <span className="purple"> Milton, ON, Canada.</span>
            <br />
            Currently a Level ||| <span className="purple">Software Engineering & Management student</span> @ McMaster University
            <br />
            Current <span className="purple">Full Stack Developer</span> @ McMaster Google Developer Student Clubs 
            <br />
            Previous <span className="purple">Software Developer Intern</span> @ Advantage Group International
            <br />
            <br />
            Apart from coding, some of my hobbies are:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Motorcycles 🏍️
            </li>
            <li className="about-activity">
              <ImPointRight /> Gaming 🎮
            </li>
            <li className="about-activity">
              <ImPointRight /> Soccer ⚽️
            </li>
            <li className="about-activity">
              <ImPointRight /> Basketball 🏀
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
